
// import React, { useState, useEffect } from "react";
// import "./predocument.css";
// import { FaCloudUploadAlt } from "react-icons/fa";
// import { ImSpinner2 } from "react-icons/im";
// import axios from "axios";
// import { useParams } from "react-router";

// const initialDocuments = [
//   { id: "claim-form", name: "Final Invoice" },
// ];

// const initialAdditionalDocuments = [
//   { id: "document-1", name: "Document 1" },
//   { id: "document-2", name: "Document 2" },
//   { id: "document-3", name: "Document 3" },
// ];

// const PreInvoiceDocumentStatus = () => {
//   const { claimNumber } = useParams();
//   const [uploadedDocs, setUploadedDocs] = useState({});
//   const [loadingDocs, setLoadingDocs] = useState(true);

//   const [uploadingDocIds, setUploadingDocIds] = useState([]);
//   const [additionalDocuments, setAdditionalDocuments] = useState(initialAdditionalDocuments);

//   const azureBaseUrl = "https://caisdatahouse.blob.core.windows.net/insurance-inspection/";
//   const sasToken = "sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D";

//   const checkDocumentExistence = async (docId) => {
//     try {
//       const blobName = `Post-repair-documents/${claimNumber}_post_${docId}`;
//       const response = await axios.post('/process_data/check_document_exists', { blobName });
//       return response.data.exists;
//     } catch (error) {
//       console.error('Error checking document existence:', error.message);
//       return false;
//     }
//   };

//   useEffect(() => {
//     const fetchExistingDocs = async () => {
//       const updatedDocs = {};

//       const checkAndAddDocs = async (docs) => {
//         for (const doc of docs) {
//           const exists = await checkDocumentExistence(doc.id);
//           if (exists) {
//             const blobName = `Post-repair-documents/${claimNumber}_post_${doc.id}`;
//             updatedDocs[doc.id] = `${azureBaseUrl}${blobName}?${sasToken}`;
//           }
//         }
//       };

//       await checkAndAddDocs(initialDocuments);
//       await checkAndAddDocs(initialAdditionalDocuments);

//       setUploadedDocs(updatedDocs);
//       setLoadingDocs(false); // ✅ stop loader once done

//     };

    

//     fetchExistingDocs();
//   }, [claimNumber]);
  

//   const handleFileUpload = (event, docId) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onloadend = async () => {
//       const blobName = `Post-repair-documents/${claimNumber}_post_${docId}`;
//       const base64String = reader.result.split(",")[1];
//       const contentType = file.type;

//       try {
//         setUploadingDocIds((prev) => [...prev, docId]);

//         const response = await axios.post("/process_data/upload-file", {
//           blobName,
//           fileContent: base64String,
//           contentType,
//         });

//         if (response.status === 200 || response.status === 201) {
//           const uploadedUrl = `${azureBaseUrl}${blobName}?${sasToken}`;
//           setUploadedDocs((prev) => ({ ...prev, [docId]: uploadedUrl }));

//           await axios.post('/process_data/update_post_repair_doc', {
//             claimNumber,
//           });
//         } else {
//           alert("Upload failed. Please try again.");
//         }
//       } catch (error) {
//         console.error("Upload error:", error.message);
//         alert("Something went wrong during upload.");
//       } finally {
//         setUploadingDocIds((prev) => prev.filter((id) => id !== docId));
//       }
//     };

//     reader.readAsDataURL(file);
//   };

//   const addAdditionalDocument = () => {
//     const newDoc = {
//       id: `document-${additionalDocuments.length + 1}`,
//       name: `Document ${additionalDocuments.length + 1}`,
//     };
//     setAdditionalDocuments([...additionalDocuments, newDoc]);
//   };

//   const renderDocumentCard = (doc) => (
//     <div className="document-card" key={doc.id}>
//       <div className="text-content">
//         <p className="document-name">{doc.name}</p>
//       </div>

//       {uploadedDocs[doc.id] ? (
//         <button
//           className="action-btn preview"
//           onClick={() => window.open(uploadedDocs[doc.id], "_blank")}
//         >
//           Preview
//         </button>
//       ) : uploadingDocIds.includes(doc.id) ? (
//         <button className="action-btn uploading" disabled>
//           <ImSpinner2 className="spinner" /> Uploading...
//         </button>
//       ) : (
//         <>
//           <input
//             type="file"
//             id={doc.id}
//             style={{ display: "none" }}
//             onChange={(e) => handleFileUpload(e, doc.id)}
//           />
//           <button
//             className="action-btn upload"
//             onClick={() => document.getElementById(doc.id).click()}
//           >
//             <FaCloudUploadAlt /> Upload
//           </button>
//         </>
//       )}
//     </div>
//   );

  
// if (loadingDocs) {
//   return (
//     <div className="document-status-container loader-center">
//       <ImSpinner2 className="spinner" style={{ fontSize: 40, animation: "spin 1s linear infinite" }} />
//       <p>Fetching documents...</p>
//     </div>
//   );
// }

//   return (
    
//     <div className="document-status-container">
//       <div className="title-container">
//         <h2 className="title">Additional Documents</h2>
//         <img
//           src="https://www.iconpacks.net/icons/1/free-document-icon-901-thumb.png"
//           alt="Logo"
//           className="document-logo"
//         />
//       </div>

//       <div className="documents-grid">
//         {additionalDocuments.map(renderDocumentCard)}
//       </div>

//       <button className="upload-additional" onClick={addAdditionalDocument}>
//         Add Additional Document
//       </button>
//     </div>
//   );
// };

// export default PreInvoiceDocumentStatus;

import React, { useState, useEffect } from "react";
import "./predocument.css";
import { FaCloudUploadAlt } from "react-icons/fa";
import { ImSpinner2 } from "react-icons/im";
import axios from "axios";
import { useParams } from "react-router";

const initialDocuments = [
  { id: "claim-form", name: "Final Invoice" },
];

const initialAdditionalDocuments = [
  { id: "document-1", name: "Document 1" },
  { id: "document-2", name: "Document 2" },
  { id: "document-3", name: "Document 3" },
];

const PreInvoiceDocumentStatus = () => {
  const { claimNumber } = useParams();
  const [uploadedDocs, setUploadedDocs] = useState({});
  const [loadingDocs, setLoadingDocs] = useState(true);
  const [uploadingDocIds, setUploadingDocIds] = useState([]);
  const [additionalDocuments, setAdditionalDocuments] = useState(initialAdditionalDocuments);

  // ✅ Check if document exists in S3 and get signed URL
  const checkDocumentExistence = async (docId) => {
    try {
      const blobName = `Post-repair-documents/${claimNumber}_post_${docId}`;
      const response = await axios.post("/process_data/check_document_exists", { blobName });
      if (response.data.exists) {
        return response.data.url; // ✅ S3 signed URL with inline disposition
      }
      return null;
    } catch (error) {
      console.error("Error checking document existence:", error.message);
      return null;
    }
  };

  // ✅ Fetch existing documents from S3
  useEffect(() => {
    const fetchExistingDocs = async () => {
      const updatedDocs = {};

      const checkAndAddDocs = async (docs) => {
        for (const doc of docs) {
          const fileUrl = await checkDocumentExistence(doc.id);
          if (fileUrl) {
            updatedDocs[doc.id] = fileUrl;
          }
        }
      };

      await checkAndAddDocs(initialDocuments);
      await checkAndAddDocs(initialAdditionalDocuments);

      setUploadedDocs(updatedDocs);
      setLoadingDocs(false);
    };

    fetchExistingDocs();
  }, [claimNumber]);

  // ✅ Handle file upload to S3
  const handleFileUpload = (event, docId) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = async () => {
      const blobName = `Post-repair-documents/${claimNumber}_post_${docId}`;
      const base64String = reader.result.split(",")[1];
      const contentType = file.type;

      try {
        setUploadingDocIds((prev) => [...prev, docId]);

        const response = await axios.post("/process_data/upload-file", {
          blobName,
          fileContent: base64String,
          contentType,
        });

        if (response.status === 200 || response.status === 201) {
          const uploadedUrl = response.data.url; // ✅ S3 signed URL
          setUploadedDocs((prev) => ({ ...prev, [docId]: uploadedUrl }));

          // ✅ Update DB flag
          await axios.post("/process_data/update_post_repair_doc", { claimNumber });
        } else {
          alert("Upload failed. Please try again.");
        }
      } catch (error) {
        console.error("Upload error:", error.message);
        alert("Something went wrong during upload.");
      } finally {
        setUploadingDocIds((prev) => prev.filter((id) => id !== docId));
      }
    };

    reader.readAsDataURL(file);
  };

  // ✅ Add new additional document dynamically
  const addAdditionalDocument = () => {
    const newDoc = {
      id: `document-${additionalDocuments.length + 1}`,
      name: `Document ${additionalDocuments.length + 1}`,
    };
    setAdditionalDocuments([...additionalDocuments, newDoc]);
  };

  // ✅ Render each document card
  const renderDocumentCard = (doc) => (
    <div className="document-card" key={doc.id}>
      <div className="text-content">
        <p className="document-name">{doc.name}</p>
      </div>

      {uploadedDocs[doc.id] ? (
        <button
          className="action-btn preview"
          onClick={() => window.open(uploadedDocs[doc.id], "_blank")} // ✅ Opens in new tab
        >
          Preview
        </button>
      ) : uploadingDocIds.includes(doc.id) ? (
        <button className="action-btn uploading" disabled>
          <ImSpinner2 className="spinner" /> Uploading...
        </button>
      ) : (
        <>
          <input
            type="file"
            id={doc.id}
            style={{ display: "none" }}
            onChange={(e) => handleFileUpload(e, doc.id)}
          />
          <button
            className="action-btn upload"
            onClick={() => document.getElementById(doc.id).click()}
          >
            <FaCloudUploadAlt /> Upload
          </button>
        </>
      )}
    </div>
  );

  // ✅ Loader while fetching documents
  if (loadingDocs) {
    return (
      <div className="document-status-container loader-center">
        <ImSpinner2 className="spinner" style={{ fontSize: 40, animation: "spin 1s linear infinite" }} />
        <p>Fetching documents...</p>
      </div>
    );
  }

  return (
    <div className="document-status-container">
      <div className="title-container">
        <h2 className="title">Additional Documents</h2>
        <img
          src="https://www.iconpacks.net/icons/1/free-document-icon-901-thumb.png"
          alt="Logo"
          className="document-logo"
        />
      </div>

      <div className="documents-grid">
        {additionalDocuments.map(renderDocumentCard)}
      </div>

      <button className="upload-additional" onClick={addAdditionalDocument}>
        Add Additional Document
      </button>
    </div>
  );
};

export default PreInvoiceDocumentStatus;
